import { getError } from '@/utils/helpers';
import UserGroupService from '@/services/UserGroupService';

export const namespaced = true;

function setPaginatedUserGroups(commit, response) {
  commit('SET_GROUPS', response.data.data);
  commit('SET_META', response.data.meta);
  commit('SET_LINKS', response.data.links);
  setSuccess(commit);
}

function setUserGroup(commit, response) {
  commit('SET_GROUP', response.data.data);
  commit('SET_META', response.data.meta);
  setSuccess(commit);
}

function setSuccess(commit) {
  commit('SET_LOADING', false);
  commit('SET_SUCCESS', true);
}

function setMessage(dispatch, message) {
  dispatch('ui/snackbarSuccess', message, { root: true });
}

function setError(dispatch, commit, error) {
  commit('SET_LOADING', false);
  commit('SET_SUCCESS', false);
  commit('SET_ERROR', error);
  dispatch('ui/snackbarError', error, { root: true });
}

export const state = {
  userGroups: [],
  userGroup: {},
  meta: null,
  links: null,
  loading: false,
  error: null,
  success: null
};

export const mutations = {
  SET_GROUPS(state, userGroups) {
    state.userGroups = userGroups;
  },
  SET_GROUP(state, userGroup) {
    state.userGroup = userGroup;
  },
  SET_META(state, meta) {
    state.meta = meta;
  },
  SET_LINKS(state, links) {
    state.links = links;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
  SET_SUCCESS(state, success) {
    state.success = success;
  }
};

export const actions = {
  search({ dispatch, commit }, searchQuery) {
    commit('SET_LOADING', true);
    UserGroupService.search(searchQuery)
      .then(response => {
        setPaginatedUserGroups(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  list({ dispatch, commit }, page) {
    commit('SET_LOADING', true);
    UserGroupService.list(page)
      .then(response => {
        setPaginatedUserGroups(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  get({ dispatch, commit }, id) {
    commit('SET_LOADING', true);
    UserGroupService.get(id)
      .then(response => {
        setUserGroup(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  save({ dispatch, commit }, data) {
    commit('SET_LOADING', true);
    UserGroupService.save(data.id, data.userGroup)
      .then(response => {
        setUserGroup(commit, response);
        setMessage(dispatch, 'Saved userGroup');
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  async delete({ dispatch, commit }, id) {
    commit('SET_LOADING', true);
    return UserGroupService.delete(id)
      .then(() => {
        setSuccess(commit);
        setMessage(dispatch, 'Deleted userGroup');
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  },
  paginate({ dispatch, commit }, link) {
    commit('SET_LOADING', true);
    UserGroupService.paginate(link)
      .then(response => {
        setPaginatedUserGroups(commit, response);
      })
      .catch(error => {
        setError(dispatch, commit, getError(error));
      });
  }
};

export const getters = {
  userGroups: state => {
    return state.userGroups;
  },
  userGroup: state => {
    return state.userGroup;
  },
  meta: state => {
    return state.meta;
  },
  links: state => {
    return state.links;
  },
  loading: state => {
    return state.loading;
  },
  error: state => {
    return state.error;
  },
  success: state => {
    return state.success;
  }
};
